module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        points: {
            type: ['number', 'null']
        },
        pointsUsed: {
            type: ['number', 'null']
        },
        psv: {
            type: ['number', 'null']
        },
        cv: {
            type: ['number', 'null']
        },
        totalDiscountedCV: {
            type: ['number', 'null']
        },
        totalDiscountedPSV: {
            type: ['number', 'null']
        },
        sharingBonus: {
            type: ['string', 'number', 'null']
        },
        savings: {
            type: ['number', 'null']
        },
        shipping: {
            type: ['number', 'null']
        },
        freightPromoSavings: {
            type: ['number', 'null']
        },
        productPromoSavings: {
            type: ['number', 'null']
        },
        taxBase: {
            type: ['number', 'null']
        },
        rounding: {
            type: ['number', 'null']
        },
        taxInclusive: {
            type: ['boolean', 'null']
        },
        grandTotal: {
            type: ['number', 'null']
        },
        itemSubtotal: {
            type: ['number', 'null']
        },
        tax: {
            type: ['number', 'null']
        },
        //custom fields
        installmentFee: {
            type: ['number', 'null']
        },
        installmentTem: {
            type: ['number', 'null']
        },
        installmentTea: {
            type: ['number', 'null']
        },
        instalmentCft: {
            type: ['number', 'null']
        },
        suppTaxOne: {
            type: ['number', 'null']
        }
    }
};
